import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { LocalOffersDataSource } from '../../services/local-offers-data-source';
import { LocalOffersApiService } from '../../services/local-offers-api-service';
import { LocalOffersEdit } from '../edit/component';

@Component({
    selector: 'offers-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class OffersList implements OnInit, OnDestroy {
  private Subscriptions: Subscription[] = [];
  public DataSource = new LocalOffersDataSource(
    this.LocalOffersApi,
    'admin',
    this.data.listingId
  );
  public loading: boolean;
  public LocalOffers;
  public PageEvent: PageEvent;
  public listingTitle;

  public displayedColumns = ['company_name', 'offer', 'actions'];

  constructor(
    private dialog: MatDialog,
    private LocalOffersApi: LocalOffersApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {}

  async ngOnInit() {
    this.DataSource.connect().value;
    this.listingTitle = this.data.listingTitle;
    await this.DataSource.loadWithPageEvent();

    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );

    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (_LocalOffers) => (this.LocalOffers = _LocalOffers)
      )
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(
        (filter) => filter && this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  public deleteLocalOffer(LocalOffer) {
    confirm('Are you sure you want to delete: ' + LocalOffer.offer) &&
      this.DataSource.delete(LocalOffer);
  }

  public editOffer(LocalOffer?) {
    const config = new MatDialogConfig();
    const LocalOfferCompany = {
      ...LocalOffer,
      ...{ company_name: this.data.companyName },
    };
    config.disableClose = true;
    config.data = {
      LocalOffer: LocalOfferCompany,
      listingId: this.data.listingId || null,
      dataSource: this.DataSource,
      orgId: this.data.orgId,
    };
    this.dialog.open(LocalOffersEdit, config);
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
